import { EVENT_TYPE } from '../constants/eventTypes.js';

/** Direct ask awaiting an official answer (not broadcast thread context). */
export function isDirectQuestionAwaitingAnswer(event) {
  return (
    event?.type === EVENT_TYPE.QUESTION &&
    event?.status === 'awaiting_reply' &&
    event?.detail?.questionVariant !== 'broadcast'
  );
}
